import { render, staticRenderFns } from "./inquiry_list.vue?vue&type=template&id=0dc95233&scoped=true"
import script from "./inquiry_list.vue?vue&type=script&lang=js"
export * from "./inquiry_list.vue?vue&type=script&lang=js"
import style0 from "./inquiry_list.vue?vue&type=style&index=0&id=0dc95233&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc95233",
  null
  
)

export default component.exports